export const joinRender = (array, renderFunc, joinString) => (
  array.flatMap((e, i) => ((i > 0) ? [joinString, renderFunc(e)] : [renderFunc(e)]))
);

export const arraysEqual = (firstArray, secondArray) => {
  if (!firstArray || !secondArray) {
    return firstArray === secondArray;
  }
  if (firstArray.length !== secondArray.length) {
    return false;
  }
  return firstArray.every((val, index) => val === secondArray[index]);
};
